import {
  ColumnDefinition,
  OuiBadgeComponent,
  OuiBoxComponent,
  OuiRecordDatasource as OuiDatasource,
  OuiDataTableComponent,
  OuiDialogComponent,
  OuiDialogHeaderComponent,
  OuiExpandComponent,
  OuiExpandToggleComponent,
  OuiIconButtonComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiSymbolComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import {
  Component,
  effect,
  inject,
  input,
  output,
  signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { WorkflowLogEntry } from '../../models/workflow-history.model';
import { LogsService } from '../../services/logs/logs.service';

@Component({
  selector: 'app-log-table',
  imports: [
    OuiDataTableComponent,
    OuiTextComponent,
    OuiRowComponent,
    OuiDialogComponent,
    OuiDialogHeaderComponent,
    OuiStackComponent,
    OuiExpandComponent,
    OuiExpandToggleComponent,
    OuiSymbolComponent,
    OuiIconButtonComponent,
    OuiBadgeComponent,
    OuiBoxComponent,
  ],
  templateUrl: './log-table.component.html',
})
export class LogTableComponent {
  logs = inject(LogsService);
  datasource = input<OuiDatasource<WorkflowLogEntry>>();
  label = input<string>('Logs');
  loading = input<boolean>(false);
  heightOffset = input<number>(500);
  reload = output();

  statusCell = viewChild<TemplateRef<never>>('statusCell');

  showDialog = signal<boolean>(false);

  details = signal<WorkflowLogEntry[] | undefined>(undefined);

  columns!: ColumnDefinition<WorkflowLogEntry>[];

  constructor() {
    effect(() => {
      this.datasource()?.sortRecords({
        column: 'timestampDate',
        direction: 'asc',
      });
    });

    effect(() => {
      this.columns = [
        {
          columnDef: 'jobStatus',
          header: 'Job Status',
          template: this.statusCell(),
        },
        /*        {
          columnDef: 'regionId',
          header: 'Regions',
        },*/
        {
          columnDef: 'userId',
          header: 'Upload User',
        },
        {
          columnDef: 'timestampDate',
          header: 'Date and Time',
          cell: (element) => element.timestamp,
        },
      ];
    });
  }

  handleRowClick(entry: WorkflowLogEntry) {
    this.details.set(undefined);
    this.logs.getLogEntryDetails$(entry.correlationId).subscribe({
      next: (details) => {
        this.details.set(details);
      },
    });
    this.showDialog.set(true);
  }

  protected readonly JSON = JSON;
  protected readonly Object = Object;

  reloadData() {
    this.reload.emit();
  }
}
